namespace RecordShield.Workspace {
    export interface ActivitiesRow {
        Id?: number;
        LastAnalyticsId?: number;
        ActivationId?: number;
        ProductId?: number;
        PId?: number;
        ProductItemId?: number;
        UserId?: number;
        SerialKey?: string;
        ContentKey?: number;
        Views?: number;
        WatchDurationInSeconds?: number;
        TenantId?: number;
        PlayedAt?: string;
        ProductName?: string;
        Code?: number;
        Subscriber?: string;
        Name?: string;
        MIMEType?: string;
        Length?: number;
        Size?: number;
        CustomerKey?: number;
        Extension?: string;
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
    }

    export namespace ActivitiesRow {
        export const idProperty = 'Id';
        export const nameProperty = 'SerialKey';
        export const localTextPrefix = 'Workspace.Activities';

        export namespace Fields {
            export declare const Id: string;
            export declare const LastAnalyticsId: string;
            export declare const ActivationId: string;
            export declare const ProductId: string;
            export declare const PId: string;
            export declare const ProductItemId: string;
            export declare const UserId: string;
            export declare const SerialKey: string;
            export declare const ContentKey: string;
            export declare const Views: string;
            export declare const WatchDurationInSeconds: string;
            export declare const TenantId: string;
            export declare const PlayedAt: string;
            export declare const ProductName: string;
            export declare const Code: string;
            export declare const Subscriber: string;
            export declare const Name: string;
            export declare const MIMEType: string;
            export declare const Length: string;
            export declare const Size: string;
            export declare const CustomerKey: string;
            export declare const Extension: string;
            export declare const InsertUserId: string;
            export declare const InsertDate: string;
            export declare const UpdateUserId: string;
            export declare const UpdateDate: string;
        }

        ['Id', 'LastAnalyticsId', 'ActivationId', 'ProductId', 'PId', 'ProductItemId', 'UserId', 'SerialKey', 'ContentKey', 'Views', 'WatchDurationInSeconds', 'TenantId', 'PlayedAt', 'ProductName', 'Code', 'Subscriber', 'Name', 'MIMEType', 'Length', 'Size', 'CustomerKey', 'Extension', 'InsertUserId', 'InsertDate', 'UpdateUserId', 'UpdateDate'].forEach(x => (<any>Fields)[x] = x);
    }
}
